import React from 'react';

import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/fancy-example.css';

export function AccordionComponent({ items }) {
	return <Accordion allowZeroExpanded={true}>
		{items.map(item => (
			<AccordionItem key={item.head}>
				<AccordionItemHeading>
					<AccordionItemButton>
						{item.head}
					</AccordionItemButton>
				</AccordionItemHeading>
				<AccordionItemPanel>
					{item.body}
				</AccordionItemPanel>
			</AccordionItem>
		))}
	</Accordion>
}
